import React, {ReactNode} from "react";
import ReactMarkdown from "react-markdown";
import i18next, {StringMap, TOptions} from "i18next";
import {Trans} from "react-i18next";
import {micromark} from 'micromark'
import Configuration from "../configuration/PortalConfiguration";
import FunctionHelper from "../helper/FunctionHelper";
import {TranslateProperties} from "./TranslateInterface";
import PortalPureComponent from "../components/PortalPureComponent";

/**
 * A Translate component is used to wrap the {@link i18next} translate functions, make the easier to use and adds
 * additional capabilities. for additional information to the translation classes see:
 * <a href="https://www.i18next.com/overview">https://www.i18next.com/</a>
 */
export default class Translate extends PortalPureComponent<TranslateProperties, any> {
	/**
	 * Translates a given translation key with the given options. The used namespace/translation file defaults to
	 * **general** if you want to use a different one the option **ns** must be set
	 */
	public static value<TInterpolationMap extends object = StringMap>(
		key: string, options?: TOptions<TInterpolationMap>, markdown?: boolean
	): string {
		if (FunctionHelper.applyValue(Configuration.fixedAdminLanguage, true)) {
			options = FunctionHelper.applyValue({...options, lng: "en"}, {lng: "en"});
		}

		let result: string = i18next.t(key, {...options});

		if (markdown) {
			result = micromark(result);
		}

		return result;
	}

	/**
	 * Checks if a given translation key exists. The used namespace/translation file defaults to
	 * **general** if you want to use a different one the option **ns** must be set
	 */
	public static exists<TInterpolationMap extends object = StringMap>(
		data: string, options?: TOptions<TInterpolationMap>
	): boolean {
		return i18next.exists(data, options);
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let lang: string | undefined;
		if (FunctionHelper.applyValue(Configuration.fixedAdminLanguage, true)) {
			lang = "en";
		}

		return (
			<>
				{this.props.markdown ?
					<ReactMarkdown linkTarget={"_blank"}>
						{Translate.value(this.props.data, {
							ns: this.props.namespace, context: this.props.values
						})}
					</ReactMarkdown> :
					<Trans i18nKey={this.props.data} ns={this.props.namespace} values={this.props.values}
						   lang={lang}/>
				}
			</>
		);
	}
}